import React from "react";
// import Layout from "./layout";
const Layout=React.lazy(()=>import('./layout'))
const AppLayout = ({ children }) => {
 
  return <Layout children={children} />;
};
export default AppLayout;
// AppLayout.propTypes = {
//   children: propTypes.element.isRequuired,
// };
